import { Injectable } from '@angular/core';
import { API } from './api';
import { LogoutProvider } from './logout';
import { UserProvider } from './user';

@Injectable()
export class AccountProvider {
    public isSent = false;

    constructor(private api: API, private logoutProvider: LogoutProvider, private userProvider: UserProvider) {}

    public async updatePassword(currentPassword, password): Promise<any> {
        return await this.api.post('users/changePassword', {
            currentPassword,
            password
        });
    }

    public async requestSwitch(isResent: boolean = false): Promise<void> {
        if (!this.isSent || isResent) {
            await this.api.post('users/switch/request', {});
            this.isSent = true;
        }
    }

    public async switchAccount(email: string, token: string): Promise<void> {
        if (!this.userProvider.canSwitchAccount()) {
            return;
        }

        const resp = await this.api.post('users/switch', {
            email,
            token
        });

        this.isSent = false;

        if (resp.success) {
            const newToken = resp.message;
            await this.logoutProvider.logout();
            this.api.setWheatleyToken(newToken);
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/account.ts